export default () => {
  var $window = $(window),
      $widgets = $('.m1-find-vehicle-by-type:not(".initialized")'),
      scrollBarHeight = 30;

  $widgets.each(function(index, widget) {
    var $widget = $(widget),
        $items = $widget.find('.item'),
        $imgs = $items.find('img'),
        maxHeight = 0,
        itemsCount = $items.length,
        $firstItem = $items.eq(0),
        $leftSizer = $widget.find('.left-sizer'),
        params = $widget.data();

    var $listWrapper = $widget.find('.listScrollWrapper'),
        $list = $widget.find('.cselist'),
        $scroller = $list,
        scale = params.scale,
        scaleHalf = scale / 2,
        scaleQuarter = scale / 4,
        itemWidth = 0,
        halfItemWidth = itemWidth,
        listRect,
        lastScroll = 0,
        cursorProgress;

    $widget.on('click', '.item', function(event) {
      var $item = $(this);

      window.location.href = params.url + '?vehicle_type=' + $item.data('code');
    });

    $window.on('resize', recalculateSizes);
    
    $list.on('mousemove', function(event) {
      updateScrollOffset(event.pageX);
    });

    $list.on('scroll', function(event) {
      if (window.innerWidth < 1100) return;

      // we need to recalculated items positions if block containing widget
      // has chagne it's scroll left position
      if (lastScroll !== $scroller.scrollLeft()) {
        recalculateSizes();
      }
      updateScales();
    });


    function updateScales() {
      var leftOffset = $list.scrollLeft() + (cursorProgress * listRect.width) - ($leftSizer.outerWidth()),
          elIndex;

      leftOffset = leftOffset < 0 ? 0 : leftOffset;

      elIndex = Math.ceil(leftOffset / itemWidth);

      var itemOffset = leftOffset % itemWidth,
          itemScale = scaleHalf,
          moreThanHalf;

      if (itemOffset === 0) {
        moreThanHalf = true;
        
        // this covers edge cases, when cursor is between items or at the edges of widget
        if (itemsCount === elIndex || elIndex === 0) {
          itemScale = scale;
        } else {
          itemScale = scaleHalf;
        }
      } else if (itemOffset < halfItemWidth) {
        moreThanHalf = false;

        if ([0,1].indexOf(elIndex) !== -1) {
          itemScale = scale;
        } else {
          itemScale += (itemOffset / halfItemWidth) * scaleHalf; 
        }
      } else {
        moreThanHalf = true;

        if (itemsCount === elIndex) {
          itemScale = scale;
        } else {
          itemScale += scaleHalf - ((itemOffset - halfItemWidth) / halfItemWidth)  * scaleHalf;
        }
      }
      
      var margin = halfItemWidth * scaleHalf;

      if (elIndex > itemsCount) {
        return;
      }

      if (elIndex > 0) {
        elIndex -= 1;
      }

      $items.each(function(index, item) {
        item.style.transform = 'scale('+1+')';
        item.style.zIndex = 1;
        item.classList.remove('current');
      }, this);

      $items[elIndex].style.transform = 'scale('+ (1 + itemScale)+')';
      $items[elIndex].style.zIndex = 2;
      $items[elIndex].classList.add('current');

      if (moreThanHalf) {
        if (elIndex + 1 !== itemsCount) {
          $items[elIndex + 1].style.transform = 'scale('+ (1 + scale - itemScale) +')';
        }
      } else {
        if (elIndex !== 0) {
          $items[elIndex - 1].style.transform = 'scale('+ (1 + scale - itemScale) +')';
        }
      }

      $items.each(function(index, item) {
        if (elIndex + 1 === index) {
          if (moreThanHalf) {
            item.style.transform += ' translateX('+ (margin * itemScale) +'px)';
          } else {
            item.style.transform += ' translateX('+ margin * scale +'px)'
          }
        } else if (elIndex - 1 === index) {
          if (!moreThanHalf) {
            item.style.transform += ' translateX('+ -(margin * itemScale) +'px)';
          } else {
            item.style.transform += ' translateX('+ -margin * scale +'px)'
          }
        } else if (index < elIndex) {
          item.style.transform += ' translateX('+ -margin * scale +'px)'
        } else if (index > elIndex) {
          item.style.transform += ' translateX('+ margin * scale +'px)'

        // if this element
        } else {
          if (moreThanHalf) {
            item.style.transform += ' translateX('+ (margin * (itemScale - scale)) +'px)';
          } else {
            item.style.transform += ' translateX('+ -(margin * (itemScale - scale)) +'px)';
          }
        }
      }, this);
    }
    function updateScrollOffset(cursorPosition) {
      if (!listRect) return;
      
      cursorPosition = typeof cursorPosition === 'number' ? cursorPosition : listRect.width / 2;
  
      cursorProgress = (cursorPosition - listRect.left) / listRect.width;
      $list.scrollLeft(cursorProgress * $list[0].scrollWidth - listRect.width * cursorProgress);
    }

    function recalculate() {
      recalculateSizes();
      updateScrollOffset();
    }
    
    function recalculateSizes() {
      var scalleOffest,
          scalleOffestTop,
          scalleOffestBottom;

      lastScroll = $scroller.scrollLeft();

      itemWidth = $firstItem.outerWidth();
      halfItemWidth = itemWidth / 2;
      
      $leftSizer.css('width', itemWidth * (1 + scaleQuarter) - itemWidth) + 'px';

      listRect = $list[0].getBoundingClientRect();

      $list.css('padding', 0);
      scalleOffest = $list[0].getBoundingClientRect().height * scale;
      scalleOffestTop = (params.transformOrigin / 100) * scalleOffest;
      scalleOffestBottom = ((100 - params.transformOrigin) / 100) * scalleOffest;
      
      $list.css('padding', scalleOffestTop + 'px 0 ' + (scalleOffestBottom + scrollBarHeight) + 'px');
      
      $listWrapper.height($list.outerHeight() - scrollBarHeight + 10);
    }

    $imgs.each(function(index, img) {
      if (img.height > maxHeight) {
        maxHeight = img.height;
      }
    });
    $imgs.on('load', onImgLoad);

    function onImgLoad() {
      if (this.height > maxHeight) {
        maxHeight = this.height;
  
        recalculate();
      }
    }

    if (maxHeight > 0) {
      recalculate();
    }

    $window.on('find-vehicle-before-expand', function() {
      $widget.show();
      recalculate();
      $widget.hide();
    });

    $widget.addClass('initialized');
  });
};